import { ServicePortSummaryTable } from './ServicePortSummaryTable';
import type { ServiceFormItem } from './types';

interface ServicePreviewSectionProps {
  services?: ServiceFormItem[] | Record<string, unknown>[] | null;
  /** 只读预览下空列表是否隐藏整块，默认 true */
  hideEmptyList?: boolean;
}

/** 确认页/详情：服务端口摘要表；标题由外层模块 Card 提供，此处不再重复 */
export function ServicePreviewSection({ services, hideEmptyList = true }: ServicePreviewSectionProps) {
  const hasServices = Array.isArray(services) && services.length > 0;
  if (!hasServices && hideEmptyList) return null;

  return hasServices ? <ServicePortSummaryTable services={services} /> : null;
}
